import React from 'react';
import TagStationModal from '../../shared/component/tag/TagStationModal';
import TagStationModalMobile from '../../shared/component/tag/mobile/TagStationModalMobile';
import { useGroupMemberTag } from '../../shared/hooks/useApi/useGroupMemberTag';
import { usePageOwnerIdentityStore } from '../../shared/store/pageOwnerIdentityStore';
import { canShowGroupMemberTagList } from '../../shared/util/visibility/groupMemberVisibility';
import { useAuth } from '../../shared/hooks/useApi/useAuth';

interface GroupMemberTagStationModalProps {
  isMobile: boolean;
  setIsUserInput: (isUserInput: boolean) => void;
}

const GroupMemberTagStationModal: React.FC<GroupMemberTagStationModalProps> = ({
  isMobile,
  setIsUserInput,
}) => {
  const pageOwner = usePageOwnerIdentityStore((s) => s.pageOwner);
  const { isOwner } = useAuth();
  const {
    tags,
    listOwnerAui,
    status,
    getGroupMemberTagList,
    updateGroupMemberTag,
    deleteGroupMemberTag,
  } = useGroupMemberTag();
  const canShowTags = canShowGroupMemberTagList({
    pageOwnerAui: pageOwner?.aui,
    listOwnerAui,
    status,
  });
  const visibleTags = canShowTags ? tags : [];

  const modalProps = {
    tags: visibleTags,
    loadTags: getGroupMemberTagList,
    loadKey: pageOwner?.aui ? `${pageOwner.aui}:${isOwner ? 'owner' : 'public'}` : null,
    updateTag: updateGroupMemberTag,
    deleteTag: deleteGroupMemberTag,
    setIsUserInput,
  };

  return isMobile
    ? <TagStationModalMobile {...modalProps} />
    : <TagStationModal {...modalProps} />;
};

export default GroupMemberTagStationModal;
